/**
 * 質問票はデフォルト2件＋カスタム最大98件
 */
export const MAX_COUNT = 100;
